export default "__VITE_ASSET__BcG3d_FZ__"